// @flow

import * as React from 'react';

import { toUnicode } from 'punycode.js';

import { selectOneProductErrors, type DecoratedProduct } from '@gandi/cart';
import { useTranslator } from '@gandi/translate';

import { useAppSelector } from 'src/hooks/useAppSelector';

import ProductItem from './components/ProductItem';

type Props = {
  product: DecoratedProduct,
};

export function MarketplaceRenew({ product }: Props): React.MixedElement {
  const { __ } = useTranslator();

  const productErrors = useAppSelector(state =>
    selectOneProductErrors(state, {
      productId: product.id,
    }),
  );

  const detail = __('Renew plan for %(fqdn)s', {
    fqdn: toUnicode(product.payload.fqdn || ''),
  });

  const label = product.label || '';

  return (
    <ProductItem
      errors={productErrors}
      key={`${product.id}-row`}
      hasTaxes={product.hasTaxes}
      priceBeforeTaxes={
        product.isWorking ? undefined : product.total?.before_taxes
      }
      productId={product.id}
      label={label}
      detail={detail}
    />
  );
}
